import { render, staticRenderFns } from "./card-with-survey-text.vue?vue&type=template&id=bce47d74&"
import script from "./card-with-survey-text.vue?vue&type=script&lang=js&"
export * from "./card-with-survey-text.vue?vue&type=script&lang=js&"
import style0 from "./card-with-survey-text.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports